module.exports = __webpack_public_path__ + "static/media/add_coverage-arrow.7e1a8bec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onBoardingArrows/add_coverage-arrow.svg
// module id = 929
// module chunks = 21